// src/components/contact/MapBannerStyles.js
import styled from "styled-components";

const shadow = "rgba(0,0,0,0.28)";
const paper = "#fffdfa";
const ink = "#1e1b16";

export const MapWrap = styled.section`
  position: relative;
  width: 100%;
  /* desktop/tablet */
  height: clamp(320px, 50svh, 560px);
  overflow: hidden;

  /* harta să umple 100% containerul, nu 400px implicit */
  .map,
  .leaflet-container {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100% !important; /* <- rupe default-ul Leaflet */
    min-height: 280px; /* plasă de siguranță pe mobil */
  }

  @media (max-width: 720px) {
    height: clamp(300px, 46svh, 460px);
    padding-bottom: env(safe-area-inset-bottom, 0);
  }

  @media (max-width: 420px) {
    height: clamp(280px, 44svh, 420px);
  }
`;

/* Overlay semi-transparent care oprește scroll/pan până la click */
export const Guard = styled.div`
  position: absolute;
  inset: 0;
  z-index: 5;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.18), rgba(0, 0, 0, 0.18));
  display: grid;
  place-items: end center;
  padding: 18px;
  cursor: zoom-in;
  user-select: none;

  /* buton-ghost în partea de jos */
  &::after {
    content: "Click pentru a activa harta";
    background: rgba(255, 253, 250, 0.92);
    color: ${ink};
    border: 1px dashed rgba(0, 0, 0, 0.12);
    border-radius: 14px;
    padding: 10px 14px;
    margin-bottom: 14px;
    font-size: clamp(12px, 1.8vw, 14px);
    box-shadow: 0 10px 30px ${shadow};
  }

  &:focus {
    outline: 2px solid rgba(196, 164, 83, 0.8);
    outline-offset: -2px;
  }
`;

export const Chip = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 6;
  background: ${paper};
  color: ${ink};
  border: 1px dashed rgba(0, 0, 0, 0.12);
  border-radius: 999px;
  padding: 8px 12px;
  font-size: 12px;
  box-shadow: 0 10px 30px ${shadow};
  pointer-events: none;
`;

export const OverlayCard = styled.div`
  position: absolute;
  left: clamp(12px, 6%, 40px);
  bottom: clamp(12px, 8%, 40px);
  background: ${paper};
  color: ${ink};
  border-radius: 18px;
  padding: 16px 18px;
  width: min(460px, 86vw);
  box-shadow: 0 20px 50px ${shadow};
  border: 1px dashed rgba(0, 0, 0, 0.08);
  z-index: 4;

  @media (max-width: 720px) {
    left: 10px;
    right: 10px;
    bottom: 10px;
    width: auto;
    padding: 12px 14px;
  }
`;

export const PinTitle = styled.h3`
  margin: 0 0 6px;
  font-size: clamp(18px, 2.2vw, 22px);
`;
